module.exports = __webpack_public_path__ + "static/media/oberflex-palissandre-1200x2490.2ce1cb48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-palissandre-1200x2490.jpg
// module id = 1048
// module chunks = 37